<template>
  <!-- Edit Dialog -->
  <base-dialog
    v-model="dialog.show"
    max-width="500px"
    min-width="300px"
    scrollable
    :title="`${titleDialog} người dùng`"
    width="50%"
  >
    <div v-if="isCreateDialog">
      <v-row no-gutters>
        <v-col cols="12">
          <field-group
            v-model="dialog.data.name"
            autofocus
            :error-messages="dialog.error.name"
            filled
            label="Tên hiển thị"
            no-label
          ></field-group>
        </v-col>
        <v-col cols="12">
          <field-group
            v-model="dialog.data.username"
            :disabled="!isCreateDialog"
            :error-messages="dialog.error.username"
            filled
            label="Tên đăng nhập"
            no-label
          ></field-group>
        </v-col>
        <v-col cols="12">
          <field-group
            v-model="dialog.data.email"
            :disabled="!isCreateDialog"
            :error-messages="dialog.error.email"
            filled
            label="Email"
            no-label
          ></field-group>
        </v-col>
        <v-col cols="12">
          <field-group
            v-model="dialog.data.mobile"
            :error-messages="dialog.error.mobile"
            filled
            hint="Trường không bắt buộc"
            :label="$t('field.mobile')"
            no-label
            persistent-hint
          ></field-group>
        </v-col>
        <template v-if="isCreateDialog">
          <v-col cols="12">
            <field-group no-label>
              <template #input>
                <FieldToggleShow
                  v-model="dialog.data.password"
                  autocomplete="new-password"
                  :error-messages="dialog.error.password"
                  filled
                  hint="Mật khẩu cần ít nhất một chữ cái, một số và chứa kí tự đặc biệt:@$!%*&?"
                  :label="$t('register.password')"
                  noLabel
                  persistent-hint
                  placeholder=""
                >
                </FieldToggleShow>
              </template>
            </field-group>
          </v-col>
          <v-col cols="12">
            <field-group
              name="passwordcomfirm"
              no-label
              :rules="[passwordConfirmationRule]"
            >
              <template #input="{ rules }">
                <FieldToggleShow
                  v-model="dialog.data.password_confirmation"
                  autocomplete="new-password"
                  :error-messages="dialog.error.password_confirmation"
                  filled
                  :label="$t('register.comfirmPassword')"
                  noLabel
                  :rules="rules"
                />
              </template>
            </field-group>
          </v-col>
          <v-col cols="12">
            <v-autocomplete
              v-model="dialog.data.roles"
              dense
              :error-messages="dialog.error.role_ids"
              filled
              item-text="name"
              item-value="id"
              :items="roles.items"
              label="Quyền"
              :loading="roles.loading"
              multiple
              no-label
              return-object
              typeInput="v-select"
            >
              <template #selection="{item}">
                <v-chip
                  :color="item.meta.color"
                  :text-color="item.meta['text-color']"
                  class="py-1 px-2 text-caption ma-1 font-weight-bold"
                  dark
                  label
                >
                  {{ item.name }}
                </v-chip>
              </template>
            </v-autocomplete>
          </v-col>
        </template>
        <!-- <template v-else>
      <v-col v-if="currentId != dialog.data.id"  cols="12">
        <p class="ma-0 text-subtitle-2">Hoạt động</p>
        <v-checkbox
          v-model="dialog.data.inactive"
          class="ma-0"
          :false-value="true"
          :label="
            dialog.data.inactive
              ? ` (Tích để cho người dùng đăng nhập hệ thống)`
              : `(Bỏ tích để vô hiệu hóa người dùng)`
          "
          :true-value="false"
        >
        </v-checkbox>
      </v-col>
    </template> -->
      </v-row>
    </div>
    <div v-else>
      <base-form ref="form" lazy-validation @submit.stop="onSubmit">
        <v-tabs grow>
          <v-tab v-for="item in items" :key="item">
            {{ item }}
          </v-tab>
          <v-tab-item>
            <v-row no-gutters>
              <v-col cols="12">
                <field-group
                  v-model="dialog.data.name"
                  autofocus
                  :error-messages="dialog.error.name"
                  filled
                  label="Tên hiển thị"
                  no-label
                ></field-group>
              </v-col>
              <v-col cols="12">
                <field-group
                  v-model="dialog.data.username"
                  :disabled="!isCreateDialog"
                  :error-messages="dialog.error.username"
                  filled
                  label="Tên đăng nhập"
                  no-label
                ></field-group>
              </v-col>
              <v-col cols="12">
                <field-group
                  v-model="dialog.data.email"
                  :disabled="!isCreateDialog"
                  :error-messages="dialog.error.email"
                  filled
                  label="Email"
                  no-label
                ></field-group>
              </v-col>
              <v-col cols="12">
                <field-group
                  v-model="dialog.data.mobile"
                  :error-messages="dialog.error.mobile"
                  filled
                  hint="Trường không bắt buộc"
                  :label="$t('field.mobile')"
                  no-label
                  persistent-hint
                ></field-group>
              </v-col>
              <template v-if="isCreateDialog">
                <v-col cols="12">
                  <field-group no-label>
                    <template #input>
                      <FieldToggleShow
                        v-model="dialog.data.password"
                        autocomplete="new-password"
                        :error-messages="dialog.error.password"
                        filled
                        hint="Mật khẩu cần ít nhất một chữ cái, một số và chứa kí tự đặc biệt:@$!%*&?"
                        :label="$t('register.password')"
                        noLabel
                        persistent-hint
                        placeholder=""
                      >
                        <!-- <template v-slot:append>
                      <base-button
                        icon
                        small
                        tooltip="Tạo mật khẩu ngẫu nhiên"
                        @click="generatePassword"
                      >
                        <v-icon small>mdi-plus</v-icon>
                      </base-button>
                      <base-button
                        icon
                        small
                        tooltip="Sao chép mật khẩu"
                        @click="copyToClipboard(dialog.data.password)"
                      >
                        <v-icon small>mdi-content-copy</v-icon>
                      </base-button>
                    </template> -->
                      </FieldToggleShow>
                    </template>
                  </field-group>
                </v-col>
                <v-col cols="12">
                  <field-group
                    name="passwordcomfirm"
                    no-label
                    :rules="[passwordConfirmationRule]"
                  >
                    <template #input="{ rules }">
                      <FieldToggleShow
                        v-model="dialog.data.password_confirmation"
                        autocomplete="new-password"
                        :error-messages="dialog.error.password_confirmation"
                        filled
                        :label="$t('register.comfirmPassword')"
                        noLabel
                        :rules="rules"
                      />
                    </template>
                  </field-group>
                </v-col>
              </template>
              <!-- <template v-else>
            <v-col v-if="currentId != dialog.data.id"  cols="12">
              <p class="ma-0 text-subtitle-2">Hoạt động</p>
              <v-checkbox
                v-model="dialog.data.inactive"
                class="ma-0"
                :false-value="true"
                :label="
                  dialog.data.inactive
                    ? ` (Tích để cho người dùng đăng nhập hệ thống)`
                    : `(Bỏ tích để vô hiệu hóa người dùng)`
                "
                :true-value="false"
              >
              </v-checkbox>
            </v-col>
          </template> -->
            </v-row>
          </v-tab-item>
          <v-tab-item>
            <v-col cols="12">
              <v-autocomplete
                v-model="dialog.data.roles"
                dense
                :error-messages="dialog.error.role_ids"
                filled
                item-text="name"
                item-value="id"
                :items="roles.items"
                label="Quyền"
                :loading="roles.loading"
                multiple
                no-label
                return-object
                typeInput="v-select"
              >
                <template #selection="{item}">
                  <v-chip
                    :color="item.meta.color"
                    :text-color="item.meta['text-color']"
                    class="py-1 px-2 text-caption ma-1 font-weight-bold"
                    dark
                    label
                  >
                    {{ item.name }}
                  </v-chip>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col cols="12">
              <div v-if="dialog.data.role_id == 1">
                <h5>Quản trị hệ thống có quyền tiếp cận tất cả workspace</h5>
              </div>
              <div v-else>
                <v-expansion-panels inset class="my-1">
                  <v-expansion-panel>
                    <v-expansion-panel-header>
                      Các không gian làm việc do người này quản lý
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-list>
                        <v-list-item
                          v-for="(workspace, id) in workspaces"
                          :key="id"
                        >
                          <v-list-item-content>
                            <v-card flat>
                              {{ workspace }}
                              <v-icon
                                color="error"
                                @click="deleteWorkspace(id)"
                                right
                                >mdi-close</v-icon
                              >
                            </v-card>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                      <v-select
                        v-model="workspace"
                        :items="this.workspacesOptions"
                        label="Thêm không gian làm việc"
                        filled
                      ></v-select>
                      <v-icon color="green" @click="addWorkspace(workspace)"
                        >mdi-check</v-icon
                      >
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </div>
            </v-col>
          </v-tab-item>
        </v-tabs>
      </base-form>
    </div>

    <template v-slot:extra-btn>
      <base-button
        color="primary"
        :loading="dialog.loading"
        outlined
        :type-action="dialog.type"
        @click="onSubmit"
      >
      </base-button>
    </template>
  </base-dialog>
</template>

<script>
import FieldToggleShow from '@components/field/field-toggle-show.vue'
import { EDIT_TYPE } from '@constant'
import { API_USER } from '@api'
import { mapGetters } from 'vuex'
import axios from '@service/auth-sdk'
import workspaceDialogVue from '../../workspaces/workspace-dialog.vue'
export default {
  components: { FieldToggleShow },
  props: {
    option: { type: Object, default: () => ({}) },
    roles: { type: Object, required: true },
  },
  data: () => ({
    dialog: {
      show: false,
      loading: false,
      data: {},
      type: EDIT_TYPE.CREATE,
      error: {},
    },
    items: ['Thông tin cơ bản', 'Phân quyền'],
    workspacesOptions: [],
    workspaces: [],
    workspace: '',
  }),
  watch: {
    'dialog.data.roles': {
      handler(value) {
        if (!this.isCanSelectGroup) {
          this.dialog.data.group_id = null
        }
      },
    },
  },
  computed: {
    roles_code() {
      return this.dialog.data.roles.map((x) => x.code)
    },
    isShowRegion() {
      return (
        this.roles_code.includes('access:analyst') ||
        this.roles_code.includes('access:editor')
      )
    },
    isCanSelectGroup() {
      if (
        !this.dialog.data ||
        !this.dialog.data.roles ||
        this.dialog.data.roles.length < 1
      ) {
        return false
      }
      if (
        this.dialog.data.roles &&
        this.dialog.data.roles.length == 1 &&
        this.dialog.data.roles[0].code == 'access:admin'
      )
        return false
      return true
    },
    isShowGroup() {
      return this.roles_code.includes('access:customer')
    },
    ...mapGetters({
      currentId: 'auth/currentId',
      currentUser: 'auth/currentUser',
    }),
    passwordConfirmationRule() {
      const vm = this
      return () =>
        vm.dialog.data.password === vm.dialog.data.password_confirmation ||
        vm.$t('validation.notmatchpassword')
    },
    titleDialog() {
      if (this.isCreateDialog) {
        return this.$i18n.t('actions.add')
      } else {
        return this.$i18n.t('actions.update')
      }
    },
    isCreateDialog() {
      return this.dialog.type == EDIT_TYPE.CREATE
    },
  },
  methods: {
    generatePassword() {
      let password = Math.random()
        .toString(36)
        .slice(-10)
      this.$set(this.dialog.data, 'password', password)
      this.$set(this.dialog.data, 'password_confirmation', password)
    },
    open(item, type) {
      if (this.$refs.form) this.$refs.form.resetValidation()
      this.dialog.show = true
      this.dialog.type = type
      this.$set(this.dialog, 'data', Object.assign({ roles: [] }, item))
      if (!this.isCreateDialog) {
        this.getWorkspaces()
        this.getWorkspacesOptions()
      }
    },
    dialogClose() {
      this.dialog = {
        show: false,
        loading: false,
        data: {},
        type: EDIT_TYPE.CREATE,
        error: {},
      }
    },
    getWorkspacesOptions() {
      axios
        .get(`user_workspace/${this.dialog.data.id}`, {
          params: {
            type: 'others',
          },
        })
        .then((response) => {
          this.workspacesOptions = []
          for (var i = 0; i < response.data.length; i++) {
            this.workspacesOptions.push(response.data[i].name)
          }
        })
    },
    getWorkspaces() {
      axios
        .get(`user_workspace/${this.dialog.data.id}`, {
          params: {
            type: 'owned',
          },
        })
        .then((response) => {
          this.workspaces = []
          for (var i = 0; i < response.data.length; i++) {
            this.workspaces.push(response.data[i].name)
          }
        })
    },
    deleteWorkspace(id) {
      this.workspacesOptions.push(this.workspaces[id])
      this.workspaces.splice(id, 1)
    },
    addWorkspace(workspace) {
      if (workspace != '') {
        this.workspaces.push(workspace)
        this.workspacesOptions = this.workspacesOptions.filter(function(e) {
          return e !== workspace
        })
      }
    },
    setWorkspace() {
      axios.post('user_workspace', {
        user_id: this.dialog.data.id,
        workspaces: this.workspaces,
      })
    },

    async onSubmit() {
      if (!this.isCreateDialog) {
        this.setWorkspace()
      }
      this.dialog.error = {}
      //if (!(await this.$refs.form.validate())) return
      // if (
      //   this.isCreateDialog &&
      //   !passwordRegex.test(this.dialog.data.password)
      // ) {
      //   this.$set(
      //     this.dialog.error,
      //     'password',
      //     'Mật khẩu cần ít nhất một chữ cái, một số và chứa kí tự đặc biệt:@$!%*&?'
      //   )
      //   return
      // }
      try {
        let data = Object.assign({}, this.dialog.data)
        if (!this.isCanSelectGroup) {
          data.group_id = null
        }
        this.dialog.loading = true
        data.role_ids = data.roles.map((x) => x.id)
        let res = this.isCreateDialog
          ? await API_USER.create(data)
          : await API_USER.update(data.id, data)

        if (res && !res.error) {
          this.dialogClose()
          this.getData()
        }
        if (
          res &&
          res.error &&
          res.error.response &&
          res.error.response.status == 422
        ) {
          const { response } = res.error
          this.dialog.error = response.data.errors
        }
      } finally {
        this.dialog.loading = false
      }
    },
    getData() {
      this.$emit('reset')
    },
    copyToClipboard(value) {
      this.$store.dispatch('copyToClipboard', value)
    },
  },
}
</script>

<style scoped>
.v-btn {
  font-weight: 400;
}
</style>
